import { render, staticRenderFns } from "./Frequencia.vue?vue&type=template&id=6ed4f7e0&scoped=true"
import script from "./Frequencia.vue?vue&type=script&lang=js"
export * from "./Frequencia.vue?vue&type=script&lang=js"
import style0 from "./Frequencia.vue?vue&type=style&index=0&id=6ed4f7e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed4f7e0",
  null
  
)

export default component.exports